import {t} from "@lingui/core/macro";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {Spring} from "@khanacademy/wonder-blocks-layout";

/**
 * Renders pagination controls for the conversations view of guide transcripts.
 * It includes buttons to navigate to the most recent conversations and
 * to view older conversations.
 */
export function ConversationViewPagination({
    cursor,
    cursorResult,
    pathname,
}: {
    cursor: string | null | undefined;
    cursorResult: string | null | undefined;
    pathname: string;
}) {
    return (
        <View style={{flexDirection: "row"}}>
            {cursor && (
                <Button href={pathname} kind="tertiary">
                    {t`Most recent conversations`}
                </Button>
            )}
            <Spring />
            {cursorResult && (
                <Button href={`?cursor=${cursorResult}`}>
                    {t`View older conversations...`}
                </Button>
            )}
        </View>
    );
}
